import { createTheme } from '@mui/material/styles'

import lightTheme from './themeLight'
import darkTheme from './themeDark'

const CustomTheme = (type = 'dark') => {
  // const theme = type === 'light' ? lightTheme : darkTheme
  const theme = type === 'light' ? darkTheme : darkTheme
  return createTheme({
    ...theme,
  })
}

export default CustomTheme
